import { useEffect } from 'react';
const SRC = 'use-ws-cells.ts';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { setCells } from 'components/app/editor/_mediator/editor.slice';
import { getCells } from 'components/app/editor/_mediator/editor-markers/editor-markers.helper';
import { setFcCells, setFcRangeTime } from 'components/app/finalcuts/_mediator/fc-data.slice';

export const useWsCells = () => {
  const markers = useAppSelector((state) => state.editor.markers);
  const transitionTime = useAppSelector((state) => state.editor.storyConfig?.transitionTime);
  const fcMarkers = useAppSelector((state) => state.fc__data.fcMarkers);
  const duration = useAppSelector((state) => state.audio.duration);
  const dispatch = useAppDispatch();

  /* finalCuts */
  useEffect(() => {
    if (!fcMarkers.length || !duration) return;
    dispatch(setFcCells(getCells(fcMarkers, duration)));
    dispatch(setFcRangeTime(duration));
  }, [fcMarkers, duration]);

  /* storyBoard: story init */
  useEffect(() => {
    if (!duration) return;
    if (!markers || transitionTime === undefined) {
      console.error(`[${SRC}] useWsCells: storyboard`);
      return;
    }
    const cells = getCells(markers, duration);
    dispatch(setCells(cells));
  }, [duration]);
};
